import {
  ReferentielSearchResultDtoVideoTutorielDto,
  VideoTutorielDto,
} from 'lib_api/lib/api/gen';

import { FetchDataResult } from 'components/WrappedComponents/Table/types';
import { useApi } from 'hooks/ApiStoreContext';

import { FilterDashboardVideoTutoriel } from './type';

export function useSearchVideoTutoriel(
  filter: FilterDashboardVideoTutoriel,
): [
  () => Promise<ReferentielSearchResultDtoVideoTutorielDto>,
  (
    result: ReferentielSearchResultDtoVideoTutorielDto,
  ) => FetchDataResult<VideoTutorielDto>,
] {
  const controller = useApi().AdminFonctionnelControllerApi;

  return [
    () => {
      return controller.searchVideoTutorielUsingSpecsUsingGET({
        filters: {
          ...filter,
        },
      });
    },
    result => {
      return {
        data: result.results.referenceDtoList,
        total: result.total,
      };
    },
  ];
}
